<template>
  <div id="app">  
     <div class="content">
      <div class="main">
        <router-view/>
      </div>
    </div>
    <div class="footer">
      <h2 style="font-size: 100%;">This is the home of Fortnite Emotes, making it easy for you to view videos of all Emotes from Fortnite in HD</h2>
      <a href="https://fnbr.co"><img class="fnbr-logo" src="https://image.fnbr.co/logo/logo.png" alt="fnbr-logo"></a>
      <div> <a href="https://fnbr.co">Cosmetics data and images from API provided by fnbr.co</a></div>
      <div class="footer-line">Unofficial Site : Not affiliated with Epic Games</div>
      <div>©  2018 Gnejs Development</div>
    </div>
    </div>
</template>

<script>
require("@/assets/css/card.css");
export default {
  name: "App",
  components: {}
};
</script>
 
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
}

.footer-line {
  margin: 8px;
}

.fnbr-logo {
  margin: 10px;
  height: 47px;
}
.content {
  margin-left: auto;
  margin-right: auto;
}

body {
  background-color: #bf64dd;
  margin: 0px;
}

a {
  text-decoration: none;
  color: white;
}

.router-link-active {
  text-decoration: none;
}

.tc {
  text-align: center;
  justify-content: center; /* align horizontal */
  align-content: center;
  display: block;
  height: 100%;
}

@media (min-width: 576px) {
  .content {
    min-width: 576px;
  }
}

@media (min-width: 768px) {
  .content {
    min-width: 768px;
  }
}

@media (min-width: 992px) {
  .content {
    min-width: 992px;
  }
}

@media (min-width: 1200px) {
  .content {
    max-width: 1400px;
    min-width: 1200px;
  }
}

.subtitle {
  align-self: center;
  line-height: normal;
  font-family: Lato, Roboto, Calibri, Arial;
  color: white;
  font-size: 100%;
  display: block;
  width: 30%;
}

.main {
  flex: 1 0 auto;
  margin: 10px;
}

.footer {
  border: #2c3e50;
  background-color: #2c3e50;
  color: white;
  flex-shrink: 0;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue